import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import apiClient from '../lib/api';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [token, setToken] = useState('');

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    if (!tokenParam) {
      setError('Invalid or missing reset token');
    } else {
      setToken(tokenParam);
    }
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Validation
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    setIsLoading(true);

    try {
      await apiClient.auth.resetPassword(token, password);
      
      // Show success message
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to reset password');
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-container">
        <div className="auth-wrapper">
          <section className="auth-form">
            <img className="logo" src="/CityScrape Logo.svg" alt="CityScrape" />
            
            <div className="success-message">
              <h2>Password Reset Complete!</h2>
              <p>
                Your password has been successfully reset.
              </p>
              <p className="help-text">
                You can now log in with your new password.
              </p>
            </div>

            <div className="auth-footer">
              <Link to="/login" className="auth-button" style={{ textDecoration: 'none', display: 'block' }}>
                Continue to Login
              </Link>
            </div>
          </section>
        </div>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="login-container">
        <div className="auth-wrapper">
          <section className="auth-form">
            <img className="logo" src="/CityScrape Logo.svg" alt="CityScrape" />
            
            <h2>Invalid Reset Link</h2>
            <p className="auth-subtitle">
              This password reset link is invalid or has expired.
            </p>
            
            <div className="error-message">
              Invalid or missing reset token
            </div>

            <div className="auth-footer">
              <Link to="/login" className="auth-button" style={{ textDecoration: 'none', display: 'block' }}>
                Back to Login
              </Link>
            </div>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="auth-wrapper">
        <section className="auth-form">
          <img className="logo" src="/CityScrape Logo.svg" alt="CityScrape" />
          
          <h2>Set New Password</h2>
          <p className="auth-subtitle">
            Enter your new password below.
          </p>

          <form onSubmit={handleSubmit}>
            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoFocus
                minLength={8}
                placeholder="At least 8 characters"
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={8}
                placeholder="Confirm your password"
              />
            </div>

            <button 
              type="submit" 
              className="auth-button"
              disabled={isLoading}
            >
              {isLoading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>

          <div className="auth-footer" style={{ marginTop: '24px' }}>
            <Link to="/login" className="auth-link" style={{ fontSize: '14px', color: '#6b7280' }}>
              ← Back to Login
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ResetPassword;

